export default __webpack_public_path__ + "static/media/youtube.afdf35e4.png";